module.exports = __webpack_public_path__ + "static/media/logo.d7a8d95f.png";